import script from "./ProductSafetyInformations.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSafetyInformations.vue?vue&type=script&setup=true&lang=js"

import "./ProductSafetyInformations.vue?vue&type=style&index=0&id=04ad52de&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04ad52de"]])

export default __exports__